import { FC, memo } from 'react'
import { MarkerProps } from 'react-leaflet'
import dynamic from 'next/dynamic'

const Marker = dynamic(() => import('./Marker'), {
  ssr: false,
})

type Props = MarkerProps & {
  children?: JSX.Element
}

const AbstractMarker: FC<Props> = ({ children, ...props }) => {
  return <Marker {...props}>{children}</Marker>
}

export default memo(AbstractMarker)
